import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { dialogWidth, zIndex, dialogPageCentreWidth, dialogPageTakeoverWidth, enlargedInputFieldHeight, inputFieldHeight } from '../style-utils';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var AbsoluteContainer = styled('div')({}, function (props) {
  if (props.isExpanded) {
    return css({
      position: 'absolute',
      right: 0,
      zIndex: zIndex.searchDialog
    });
  }
  return {};
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var SearchDialogAnchor = styled('div')({
  position: 'relative'
}, function (props) {
  if (props.isExpanded) {
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\t\t@media screen and (max-width: ", ") {\n\t\t\t\t\tposition: fixed;\n\t\t\t\t\tz-index: ", ";\n\t\t\t\t\tleft: calc((100% - ", ") / 2);\n\t\t\t\t}\n\t\t\t\t@media screen and (max-width: ", "px) {\n\t\t\t\t\ttop: 0;\n\t\t\t\t\tright: 0;\n\t\t\t\t\tbottom: 0;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\toverflow: auto;\n\t\t\t\t}\n\t\t\t"])), dialogPageCentreWidth, zIndex.searchDialog, dialogWidth, dialogPageTakeoverWidth);
  }
  return {};
});

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var SearchAnchorWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tposition: relative;\n\t/* Prevent the input from being 200px when the icon is at the maximum icon width */\n\t@media screen and (min-width: ", "px) {\n\t\tmin-width: 200px;\n\t}\n\twidth: ", ";\n\theight: ", ";\n"])), dialogPageTakeoverWidth + 1, inputFieldHeight.px, inputFieldHeight.px);

// FIXME: convert-props-syntax rule doesn't catch this
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var EnlargedSearchAnchorWrapper = styled(SearchAnchorWrapper)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\theight: ", ";\n"])), function (props) {
  return props.isExpanded ? enlargedInputFieldHeight.px : inputFieldHeight.px;
});